import {getEndpoint, getHeaders} from "../../../helpers/endpoint";

export const fetchGodfatherLevels = (onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
      if (onRequest) onRequest();

      fetch(getEndpoint('fetchGodfatherLevels'), {
          method: 'GET',
          headers: getHeaders(getState().authentication),
      })
          .then(response => response.json()).then(data => {
          if (onSuccess) onSuccess(data);
      })
          .catch((error, type) => {
              if (onFail) onFail(type, error);
          });
  };
};

export const fetchGodfatherRegistrations = (payload, onSuccess, onFail, onRequest) => {
  return (dispatch, getState) => {
      if (onRequest) onRequest(payload);

      fetch(getEndpoint('fetchGodfatherRegistrations', payload), {
          method: 'GET',
          headers: getHeaders(getState().authentication),
      })
          .then(response => response.json()).then(data => {
          if (onSuccess) onSuccess(data, 'users');
      })
          .catch((error, type) => {
              if (onFail) onFail(type, error);
          });
  };
};


// WEBPACK FOOTER //
// ./src/actions/entities/statistics/godfather.js